import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import RowActionsMenu from '../../common/table/row-actions-menu';
import UpdateIndicator from '../../../atoms/update-indicator';

function TableHacRow({ row, t, navigate, emailStatus, showStatusColumn = true, showInvitationColumn = true, statusFilter = 'active', onDelete }) {
  const fullName = `${row.name} ${row.last_name}`;
  const navigationState = {
    breadcrumbName: fullName,
    backPath: `/admin/main/hac?status=${statusFilter || 'active'}`,
  };
  const actions = [
    {
      key: 'personal-details',
      label: t('pma-hac-tab-option1'),
      onClick: () =>
        navigate(`/common/personal-details/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'vehicles',
      label: t('pma-hac-tab-option2'),
      visible: row.status === 'active',
      onClick: () =>
        navigate(`/common/vehicles/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'preferences',
      label: t('pma-hac-tab-option3'),
      visible: row.status === 'active',
      onClick: () =>
        navigate(`/common/preferences/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'nominating-retailer',
      label: t('admin-main-tab1-option4'),
      onClick: () =>
        navigate(`/admin/nominating-retailer/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'assigned-pmas',
      label: t('admin-main-tab1-option5'),
      onClick: () =>
        navigate(`/admin/assigned-pmas/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'activity-log',
      label: t('pma-hac-tab-option8'),
      trailingContent: row.notification === true ? <UpdateIndicator /> : null,
      onClick: () =>
        navigate(`/common/activity-log/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'surveys',
      label: t('common-surveys'),
      onClick: () =>
        navigate(`/admin/surveys/${row.id}`, {
          state: navigationState,
        }),
    },
    {
      key: 'shared-notes',
      label: t('pma-hac-tab-option7'),
      onClick: () =>
        navigate(`/admin/shared-notes/${row.id}`, {
          state: navigationState,
        }),
    },
    // TODO: re-enable "delete nominee" option
    // {
    //   key: 'delete',
    //   label: t('common-delete'),
    //   visible: row.status === 'nominated',
    //   onClick: () => onDelete(row.id),
    // },
  ];

  return (
    <TableRow>
      <TableCell align="left">
        <span className="text">{row.name}</span>
      </TableCell>
      <TableCell align="left">
        <span className="text">{row.last_name}</span>
      </TableCell>
      <TableCell align="left">
        <span className="text">{row.first_pma_email}</span>
      </TableCell>
      <TableCell align="left">
        <span className="text">{row.retailer}</span>
      </TableCell>
      <TableCell align="left">
        <span className="text">{t(`countries-${row.area_code}`)}</span>
      </TableCell>
      <TableCell align="left">
        <span className="text">{t(`languages-${row.preferred_language}`)}</span>
      </TableCell>
      {showStatusColumn && (
        <TableCell align="left">
          <span className="text">
            <span className={row.login_status === 'ready' ? 'logged' : ''}>
              <span className="text">{t(`common-${row.status}`)}</span>
            </span>
          </span>
        </TableCell>
      )}
      {showInvitationColumn && (
        <TableCell align="left">
          <span className="text">{emailStatus}</span>
        </TableCell>
      )}
      <TableCell align="left">
        <span className="text">
          {row.last_update}
          {row.notification === true && <UpdateIndicator />}
        </span>
      </TableCell>
      <TableCell align="right">
        {row.status && row.status !== 'exited' ? (
          <RowActionsMenu actions={actions} />
        ) : null}
      </TableCell>
    </TableRow>
  );
}

export default TableHacRow;
